export default class UserEventRecord {
    // 创作过程认证
    static trackCommonCopyrightInfo = '版权认证_作品认证_基础信息'

    static trackCommonCopyrightSaveCategory = '版权认证_作品认证_保存自定义类型'

    static trackCommonCopyrightProcess = '版权认证_作品认证_创作过程认证'

    static trackCommonCopyrightRecharge = '版权认证_作品认证_创作过程认证_引导充值'
    
    /**
     * 作品认证
     */
    // 版权认证_作品认证_版权认证证书生成
    static trackCommonCopyrightGenerate = '版权认证_作品认证_版权认证证书生成'
    // 版权认证_作品认证_版权认证证书生成_引导充值
    static trackCommonCopyrightGenerateGuide = '版权认证_作品认证_版权认证证书生成_引导充值'
    // 版权认证_作品认证_版权认证成功
    static trackCommonCopyrightSuccess = '版权认证_作品认证_版权认证成功'

    /**
     * 已认证作品
     */
    // 版权认证_已认证作品_搜索
    static trackCommonCopyrightSearch = '版权认证_已认证作品_搜索'
    // 版权认证_已认证作品_操作
    static trackCommonCopyrightOperation = '版权认证_已认证作品_操作'
    // 版权认证_已认证作品_作品详情
    static trackCommonCopyrightDetail = '版权认证_已认证作品_作品详情'

    /**
     * 作品草稿箱
     */
    // 版权认证_作品草稿箱_搜索
    static trackCommonCopyrightDraftSearch = '版权认证_作品草稿箱_搜索'
    // 版权认证_作品草稿箱_操作
    static trackCommonCopyrightDraftOperation = '版权认证_作品草稿箱_操作'

    
    // 初始化方法
    static init () {
        window.UserEventRecord = UserEventRecord
    }
    // 通用的静态属性
    static setSuperProperty (obj) {
        zhuge.setSuperProperty(obj);
    }

    static track (name, data, callback) {
        zhuge.track(name, data, callback)
    }
}
